import { ForwardedRef, forwardRef, memo } from 'react';
import { RegistrationFieldProps } from '../../RegistrationField.types';
import { Box, FlatSelect, TextInput } from '@bonanza-social/moonlight';

export const IndustriesMap: Record<string, string> = {
  consumerProducts: 'Consumer Products',
  manufacturing: 'Manufacturing',
  service: 'Service',
  technologies: 'Technologies',
  retired: 'Retired',
  student: 'Student',
  unemployed: 'Unemployed',
  homemaker: 'Homemaker',
};

const options = Object.keys(IndustriesMap).map((id) => ({
  id,
  label: IndustriesMap[id],
}));

function IndustriesField(
  {
    onValue,
    value,
    headerNS,
    headerKey,
    placeholderNS,
    placeholderKey,
  }: RegistrationFieldProps<'industry'>,
  _: ForwardedRef<TextInput>,
) {
  return (
    <Box>
      <FlatSelect
        headerNS={headerNS}
        headerKey={headerKey}
        scrollEnabled={false}
        placeholderNS={placeholderNS}
        placeholderKey={placeholderKey}
        onValue={onValue}
        options={options}
        value={value}
      />
    </Box>
  );
}

export default memo(forwardRef(IndustriesField));
